import partial from 'lodash/partial';

import { Editor } from '@lumapps/wrex/slate';
import { createPlugin, CreatePluginEditor } from '@lumapps/wrex/slate/plugin';
import { normalizeLiftToRootNode } from '@lumapps/wrex/slate/utils/normalizeLiftToRootNode';
import { selectElementOnDelete } from '@lumapps/wrex/slate/utils/selectElementOnDelete';
import { WrexEditor } from '@lumapps/wrex/types';

import { EditableIframe } from '../components/editableBlocks/EditableIframe';
import { IframeEditor } from '../types/editor';
import { insertIframeElement } from '../utils/insertIframeElement';
import { isIframeElement } from '../utils/isIframeElement';

const createPluginEditor = (): CreatePluginEditor<IframeEditor, WrexEditor<IframeEditor>> => (editor) => {
    const { isVoid, normalizeNode, deleteBackward, deleteForward } = editor;

    return {
        normalizeNode([node, path]) {
            const pathRef = Editor.pathRef(editor, path);
            normalizeLiftToRootNode(editor, [node, path], isIframeElement);
            const changedPath = pathRef.unref();
            if (changedPath) {
                normalizeNode([node, changedPath]);
            }
        },

        isVoid: (element) => isIframeElement(element) || isVoid(element),

        deleteBackward(unit) {
            if (unit === 'character' && selectElementOnDelete(editor, false, isIframeElement)) {
                return;
            }
            deleteBackward(unit);
        },

        deleteForward(unit) {
            if (unit === 'character' && selectElementOnDelete(editor, true, isIframeElement)) {
                return;
            }
            deleteForward(unit);
        },

        insertIframeElement: partial(insertIframeElement, editor),
    };
};
export const withIframe = () =>
    createPlugin({
        createPluginEditor: createPluginEditor(),
        elements: [EditableIframe],
    });
